module.exports = __webpack_public_path__ + "img/mobile/Menus-landscape/switch_icon@1x.png?0.0.53";